import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HeatmapComponent } from './heatmap/heatmap.component';
import { TemperatureComponent } from './temperature/temperature.component';
import { Screen3Component } from './screen3/screen3.component';
import { CuringComponent } from './curing/curing.component';
import { SubviewsComponent } from './subviews/subviews.component';
import { HealthComponent } from './health/health.component';
import { ProjectComponent } from './project/project.component';
import { ProjectInformationComponent } from './project-information/project-information.component';
import { GraphComponent } from './graph/graph.component';
import { LogoutComponent } from './logout/logout.component';
import { NewComponent } from './new/new.component';
import { LoginComponent } from './login/login.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { PreferencesComponent } from './settings/preferences.component';
import { AdminLayoutComponent } from './admin/admin-layout.component';
import { CustomersComponent } from './admin/customers/customers.component';
import { DevicesComponent } from './admin/devices/devices.component';
import { UsersComponent } from './admin/users/users.component';
import { MsalGuard } from '@azure/msal-angular';
import { userAuthGuard } from './user-auth.guard';
import { adminGuard } from './admin/admin.guard';
import { CustomerSelectorComponent } from './customer-selector/customer-selector.component';

const routes: Routes = [
  {
    component: LoginComponent,
    path: 'login',
  },
  {
    component: UnauthorizedComponent,
    path: 'unauthorized',
  },
  {
    component: CustomerSelectorComponent,
    path: 'select-customer',
  },
  {
    component: MainLayoutComponent,
    path: '',
    canActivate: [userAuthGuard], // Add your authentication guard here if needed
    children: [
      {
        path: '',
        redirectTo: 'temperature',
        pathMatch: 'full'
      },
      {
        component: ProjectComponent,
        path: 'project',
      },
      {
        component: TemperatureComponent,
        path: 'temperature',
      },
      {
        component: GraphComponent,
        path: 'graph',
      },
      {
        component: CuringComponent,
        path: 'curing',
      },
      {
        component: SubviewsComponent,
        path: 'subviews',
      },
      {
        component: Screen3Component,
        path: 'notes',
      },
      {
        component: HealthComponent,
        path: 'health',
      },
      {
        component: ProjectInformationComponent,
        path: 'info',
      },
      {
        component: LogoutComponent,
        path: 'logout',
      },
      {
        component: NewComponent,
        path: 'new',
      },
      {
        path: 'settings/preferences',
        redirectTo: 'admin/preferences',
        pathMatch: 'full',
      },
      {
        path: 'admin',
        component: AdminLayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'preferences',
            pathMatch: 'full',
          },
          {
            path: 'preferences',
            component: PreferencesComponent,
          },
          {
            path: 'customers',
            component: CustomersComponent,
            canActivate: [adminGuard],
          },
          {
            path: 'devices',
            component: DevicesComponent,
            canActivate: [adminGuard],
          },
          {
            path: 'users',
            component: UsersComponent,
            canActivate: [adminGuard],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
